import styled from 'styled-components'

export const NavigationStyles = styled.div`
  .dropdown-backdrop {
    background-color: transparent !important;
  }
  .navigation {
    height: var(--navigation-height, 70px);
    position: static;
    background: var(--top-navigation-background);
    background-image: none;
    user-select: none;
    border-bottom: 1px solid var(--top-navigation-border-color);
  }
  .navigation .navigation-toggle {
    color: var(--top-navigation-toggle-text);
    font-size: 20px;
    padding: 20px;
    display: none;
    float: right;
    text-decoration: none;
    cursor: pointer;
  }
  .navigation .navigation-logo {
    width: 169.22px;
    height: 50px;
    margin: 10px 30px 0 20px;
    display: inline-block;
    float: left;
    background: no-repeat url('${STATIC_BASE_URL}/static/webapp/img/main-logo.svg');
    background-size: contain;
  }
  @media screen and (max-width: 1170px) {
    .navigation .navigation-logo {
      width: 40px;
      height: 40px;
      margin: 15px 20px;
      background-image: url('${STATIC_BASE_URL}/static/webapp/images/iron-icon.png');
    }
  }
  .navigation .navigation-content {
    height: 70px;
    display: flex;
    justify-content: space-between;
  }
  .navigation .navigation-content .navigation-group {
    height: 70px;
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 1050px) {
    .navigation .navigation-content .navigation-group {
      height: auto;
    }
  }
  .navigation .navigation-content .navigation-group.center {
    margin-left: 0;
  }
  .navigation .navigation-content .navigation-group.center .navigation-item {
    margin-right: 0;
  }
  @media screen and (min-width: 1050px) and (max-width: 1400px) {
    .navigation
      .navigation-content
      .navigation-group.center
      .navigation-item
      .navigation-item-content {
      max-width: 150px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  @media screen and (max-width: 1270px) {
    .navigation
      .navigation-content
      .navigation-group.center
      .navigation-item
      .navigation-item-content {
      max-width: 130px;
    }
  }
  .navigation .navigation-content .navigation-group.right {
    padding-right: 15px;
    float: right;
  }
  .navigation .navigation-content .navigation-item {
    position: relative;
    white-space: nowrap;
  }
  .navigation .navigation-content .navigation-item .navigation-item-content {
    color: var(--top-navigation-text);
    padding: 10px 12px;
    border-radius: 8px;
    display: flex;
    gap: 4px;
    align-items: center;
    cursor: pointer;
  }
  .navigation .navigation-content .navigation-item .navigation-item-content:hover {
    background-color: var(--top-navigation-item-hover-bg);
    text-decoration: none;
  }
  .navigation .navigation-content .navigation-item-content:focus:not(:focus-visible) {
    outline: none;
  }
  .navigation .navigation-content .navigation-item .navigation-item-content.disabled-nav-link {
    cursor: default;
  }
  .navigation .navigation-content .navigation-item .navigation-item-content img,
  .navigation .navigation-content .navigation-item .navigation-item-content i {
    margin-right: 5px;
  }
  .navigation .navigation-content .navigation-item .navigation-item-content img {
    padding-bottom: 2px;
  }
  .navigation .navigation-content .navigation-item.no-hover .navigation-item-content {
    cursor: text;
    user-select: all;
  }
  .navigation .navigation-content .navigation-item.no-hover .navigation-item-content:hover,
  .navigation .navigation-content .navigation-item.no-hover .navigation-item-content:focus {
    background-color: initial;
    text-decoration: initial;
  }
  .navigation .navigation-content .navigation-item .mw150 {
    max-width: 150px;
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  @media screen and (max-width: 1050px) {
    .navigation .navigation-content .navigation-item .mw150 {
      font-weight: bold;
    }
  }
  @media screen and (max-width: 1210px) {
    .navigation .navigation-content .navigation-item .mw150 {
      max-width: 130px;
    }
  }
  .navigation .navigation-content .navigation-item .dropdown-menu a,
  .navigation .navigation-content .navigation-item .dropdown-menu div {
    color: var(--top-navigation-dropdown-item-text);
    font-size: 13px;
    width: 100%;
    padding: 8px 15px;
    border-radius: 0;
    white-space: nowrap;
  }
  .navigation .navigation-content .navigation-item .dropdown-menu a:hover,
  .navigation .navigation-content .navigation-item .dropdown-menu div:hover {
    background-color: var(--top-navigation-dropdown-item-hover-bg);
    background-image: var(--top-navigation-dropdown-item-hover-bg-image);
  }
  .navigation .navigation-content .navigation-item .dropdown-menu a {
    color: var(--top-navigation-dropdown-link-text);
    border-top: 1px solid var(--top-navigation-dropdown-link-border);
  }
  .navigation .navigation-content .selected::before {
    height: 4px;
    content: ' ';
    position: absolute;
    top: -15px;
    right: 0;
    left: 0;
    background: var(--top-navigation-selected-indicator);
  }
  @media screen and (max-width: 1050px) {
    .navigation .navigation-content .selected::before {
      display: none;
    }
  }
  @media screen and (max-width: 1050px) {
    .navigation .navigation-toggle {
      display: inline-block;
    }
    .navigation .navigation-content {
      height: auto;
      padding: 15px 0 5px 0;
      position: absolute;
      top: 100%;
      right: 0;
      left: 0;
      display: none;
      overflow-y: scroll;
      max-height: calc(100vh - 100%);
      background-color: var(--top-navigation-mobile-content-bg);
      text-align: center;
      z-index: var(--z-index-navigation);
    }
    .navigation .navigation-content.open {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 100dvh;
    }
    .navigation .navigation-content.open .navigation-group,
    .navigation .navigation-content.open .navigation-item,
    .navigation .navigation-content.open .mw150 {
      max-width: initial !important;
      margin: 0 auto !important;
      display: block;
    }
    .navigation .navigation-content.open .navigation-item-content {
      justify-content: center;
    }
    .navigation .navigation-content.open .navigation-group.right {
      padding: 0;
      float: none !important;
    }
    .navigation .navigation-content.open .navigation-item-dropdown {
      display: block !important;
    }
  }
  .triangle {
    margin-left: 7px;
    position: relative;
    top: 1px;
  }
  @media screen and (max-width: 1050px) {
    .triangle {
      display: none;
    }
  }

  .navigation .nav-sat-label-short,
  .navigation .nav-psima-label-short {
    display: none;
  }

  /* IC-51160: compact through 2200 so a packed old top bar stays inside the
     window. Ultrawide keeps the full wordmark and long labels. */
  @media screen and (min-width: 1051px) and (max-width: 2200px) {
    .navigation {
      min-width: 0;
      max-width: 100%;
    }

    .navigation .navigation-logo {
      width: 40px;
      height: 40px;
      margin: 15px 20px;
      background-image: url('${STATIC_BASE_URL}/static/webapp/images/iron-icon.png');
      background-size: contain;
    }

    .navigation .navigation-content {
      min-width: 0;
    }

    .navigation .navigation-content .navigation-group.center {
      flex: 1;
      min-width: 0;
      overflow: hidden;
    }

    .navigation .navigation-content .navigation-group.right {
      flex-shrink: 0;
    }

    /* Center tabs: hide leading icons (wrapped DS icons + raw SVG tabs); keep badges / tags */
    .navigation .navigation-group.center .navigation-item .navigation-item-content > svg {
      display: none !important;
    }

    .navigation
      .navigation-group.center
      .navigation-item
      .navigation-item-content
      > div[id='icon-container'] {
      display: none !important;
    }

    /* Simulation & Training → S&T; Phishing Simulation Agent → PSA */
    .navigation .nav-sat-label-full,
    .navigation .nav-psima-label-full {
      display: none;
    }

    .navigation .nav-sat-label-short,
    .navigation .nav-psima-label-short {
      display: inline;
    }

    .navigation #username_dropdown .dropdown-trigger.mw150 {
      max-width: 88px;
    }
  }

  @media screen and (max-width: 1269px) {
    .navigation .navigation-group.right .toggle-icon img {
      width: 17px;
      height: 17px;
      object-fit: contain;
    }

    .navigation .navigation-group.right .toggle-icon {
      padding: 8px;
    }

    .navigation .navigation-group.right .toggle-icon:hover::before {
      width: 38px;
      height: 38px;
    }

    .navigation .navigation-group.right .bell-badge {
      left: 26px !important;
    }
  }
`
